<template>
  <div class="dsfa-netcom-download">
    <h1 class="title">360安全浏览器下载</h1>
    <dsf-virtual-scroll>
      <div class="down-box" v-if="downList.length">
        <div class="item" v-for="item in downList" :key="item.typeName">
          <p class="t">
            <img
              class="img"
              :src="downIcon[item.typeValue - 1]"
            />&nbsp;&nbsp;{{ item.typeName }}
          </p>
          <div class="list" v-if="item.packageInfos.length">
            <div
              class="child"
              v-for="child in item.packageInfos"
              :key="child.name"
            >
              <div class="c-top">
                <div class="c-text ellipsis">{{ child.name }}</div>
                <div
                  class="c-down"
                  :title="child.name"
                  @click="handleDownload(child)"
                >
                  <i class="iconfont icon-icon_down1"></i> 下载
                </div>
              </div>
              <div class="desc">{{ child.adaptationChip }}</div>
            </div>
          </div>
          <dsf-empty-data v-else></dsf-empty-data>
        </div>
      </div>
    </dsf-virtual-scroll>
    <div class="dsfa-netcom-close" @click="close()"><i class="iconfont icon-guanbi2"></i></div>
  </div>
</template>

<script>
export default {
  name: "NetcomDownloadPage",
  props: {
    activeName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      downIcon: [
        dsf.url.getWebPath('./static/img/project/icon-win.png'),
        dsf.url.getWebPath('./static/img/project/icon-ql.png'),
        dsf.url.getWebPath('./static/img/project/icon-tx.png'),
      ],
      downList: [
        {
          typeName: "Windows操作系统",
          typeValue: "1",
          packageInfos: [
            {
              name: "360(64位)",
              adaptationChip: "windows",
              fileUpload: {
                originalFileName: "360_x64.exe",
                securityLevelExpiryDate: null,
                static: false,
                securityLevelText: "默认",
                suffix: "exe",
                pageName: null,
                size: 152717400,
                uploadDate: "2024-03-26 16:44:47",
                public: true,
                securityLevelValue: -10,
                relativePath:
                  "/upload/file/exe/09fa6387f6ef4865b459475a72570d59",
                name: "360_x64",
                namespace: null,
                absolutePath:
                  "http://192.168.5.107:1023/upload/file/exe/09fa6387f6ef4865b459475a72570d59",
                id: "360_x64",
                contentType: "application/x-msdownload",
              },
            },
            {
              name: "360(32位)",
              adaptationChip: "windows",
              fileUpload: {
                originalFileName: "360_x32.exe",
                id: "360_x32",
                name: "360_x32",
              },
            },
          ],
        },
        {
          typeName: "麒麟操作系统",
          typeValue: "2",
          packageInfos: [
            {
              name: "360(麒麟版)(For ARM)",
              adaptationChip: "飞腾/麒麟",
              fileUpload: {
                originalFileName: "360(麒麟版)(For ARM).deb",
                id: "360(麒麟版)(For ARM)",
                name: "360(麒麟版)(For ARM)",
              },
            },
            {
              name: "360(麒麟版)(For LoongArch)",
              adaptationChip: "龙芯3A5000",
              fileUpload: {
                originalFileName: "360(麒麟版)(For LoongArch).deb",
                id: "360(麒麟版)(For LoongArch)",
                name: "360(麒麟版)(For LoongArch)",
              },
            },
            {
              name: "360(麒麟版)(For MIps)",
              adaptationChip: "龙芯3A3000 / 龙芯3A4000",
              fileUpload: {
                originalFileName: "360(麒麟版)(For MIps).deb",
                id: "360(麒麟版)(For MIps)",
                name: "360(麒麟版)(For MIps)",
              },
            },
            {
              name: "360(麒麟版)(For X86)",
              adaptationChip: "兆芯 / 海光 / Intel / AMD",
              fileUpload: {
                originalFileName: "360(麒麟版)(For X86).deb",
                id: "360(麒麟版)(For X86)",
                name: "360(麒麟版)(For X86)",
              },
            },
          ],
        },
        {
          typeName: "统信操作系统",
          typeValue: "3",
          packageInfos: [
            {
              name: "360(UOS版)(For ARM)",
              adaptationChip: "飞腾/麒麟",
              fileUpload: {
                originalFileName: "360(UOS版)(For ARM).deb",
                id: "360(UOS版)(For ARM)",
                name: "360(UOS版)(For ARM)",
              },
            },
            {
              name: "360(UOS版)(For LoongArch)",
              adaptationChip: "龙芯3A5000",
              fileUpload: {
                originalFileName: "360(UOS版)(For LoongArch).deb",
                id: "360(UOS版)(For LoongArch)",
                name: "360(UOS版)(For LoongArch)",
              },
            },
            {
              name: "360(UOS版)(For MIps)",
              adaptationChip: "龙芯3A3000 / 龙芯3A4000",
              fileUpload: {
                originalFileName: "360(UOS版)(For MIps).deb",
                id: "360(UOS版)(For MIps)",
                name: "360(UOS版)(For MIps)",
              },
            },
            {
              name: "360(UOS版)(For X86)",
              adaptationChip: "兆芯 / 海光 / Intel / AMD",
              fileUpload: {
                originalFileName: "360(UOS版)(For X86).deb",
                id: "360(UOS版)(For X86)",
                name: "360(UOS版)(For X86)",
              },
            },
          ],
        },
      ],
    };
  },
  watch: {},
  components: {},
  computed: {},
  created() {
    // this.getDownList();
  },
  methods: {
    getDownList() {
      dsf.$http
        .get("downloads/getBrowserInfos")
        .done(({ data, success, message }) => {
          if (success) {
            this.downList = data;
          }
        })
        .error((err) => {})
        .always(() => {});
    },
    handleDownload: function (item) {
      if (!item.fileUpload?.id) {
        dsf.layer.message("暂无下载地址", false);
        return;
      }
      dsf.layer.message("正在下载");
      dsf.file.download(
        "/static/browsers/" + item.fileUpload.originalFileName,
        {},
        item.fileUpload.originalFileName
      );
    },
    close() {
      this.$emit("download-close", false);
    },
  },
};
</script>